/* Dr. Knoop V04 · Produktseite: Galerie, Packungsgröße, Menge, In den Warenkorb (AJAX + Dialog), Tabs */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.body.classList.add('pdp-page');

  /* Alte Beschreibungen enthalten leere Absätze (&nbsp;) aus dem früheren Editor → ausblenden */
  document.querySelectorAll('.pdp-desc-text p').forEach(function (p) {
    if (!p.textContent.trim() && !p.querySelector('img, iframe, video')) p.remove();
  });

  document.querySelectorAll('[data-dk-pdp]').forEach(function (pdp) {
    var form = pdp.querySelector('[data-dk-form]');
    var variantInput = pdp.querySelector('[data-dk-variant]');
    var qty = pdp.querySelector('[data-dk-qty-input]');
    var err = pdp.querySelector('[data-dk-error]');
    var modal = document.querySelector('[data-dk-modal]');
    var scrim = modal && modal.previousElementSibling;

    /* Galerie */
    var main = pdp.querySelector('.pdp-gallery-main');
    pdp.querySelectorAll('[data-dk-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        pdp.querySelectorAll('[data-dk-thumb]').forEach(function (t) { t.classList.toggle('active', t === thumb); });
        main.querySelectorAll('[data-dk-media]').forEach(function (m) {
          var on = m.getAttribute('data-dk-media') === thumb.getAttribute('data-dk-thumb');
          m.hidden = !on;
          var v = m.querySelector('video');
          if (v) { if (on) v.play().catch(function () {}); else v.pause(); }
        });
        var type = main.querySelector('[data-dk-media]:not([hidden])');
        main.classList.toggle('show-video', !!type && type.getAttribute('data-type') !== 'image');
      });
    });

    /* Packungsgröße */
    pdp.querySelectorAll('[data-dk-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pdp.querySelectorAll('[data-dk-size]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        variantInput.value = btn.getAttribute('data-dk-size');
        document.querySelectorAll('[data-dk-price]').forEach(function (el) { el.textContent = btn.getAttribute('data-price'); });
        var base = pdp.querySelector('[data-dk-base]');
        if (base) base.innerHTML = btn.getAttribute('data-base');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.getAttribute('data-dk-size'));
        window.history.replaceState({}, '', url.toString());
      });
    });

    /* Menge */
    pdp.querySelectorAll('[data-dk-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-dk-qty') === '+' ? 1 : -1;
        qty.value = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + step));
      });
    });

    /* Dialog */
    function openModal(item) {
      if (!modal) { window.location.href = root + 'cart'; return; }
      var meta = modal.querySelector('[data-dk-modal-meta]');
      var price = modal.querySelector('[data-dk-modal-price]');
      var size = pdp.querySelector('[data-dk-size].active .pdp-size-weight');
      if (meta) meta.textContent = (size ? size.textContent.trim() + ' · ' : '') + item.quantity + '×';
      if (price) { var p = document.querySelector('.pdp-price[data-dk-price]'); price.textContent = p ? p.textContent : ''; }
      modal.hidden = false; scrim.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('visible'); scrim.classList.add('visible'); });
      document.body.style.overflow = 'hidden';
      var first = modal.querySelector('.atc-express'); if (first) first.focus();
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('visible'); scrim.classList.remove('visible');
      setTimeout(function () { modal.hidden = true; scrim.hidden = true; }, 250);
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-dk-modal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });

    /* In den Warenkorb */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = document.querySelectorAll('[data-dk-atc], button[form="' + form.id + '"]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      if (err) err.hidden = true;
      var fd = new FormData(form);
      fd.append('sections', 'cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Fehler');
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.j.sections && res.j.sections['cart-icon-bubble']) {
            var tmp = document.createElement('div'); tmp.innerHTML = res.j.sections['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section');
            bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
          }
          openModal(res.j);
        })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
        .finally(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    });
  });

  /* Tabs */
  document.querySelectorAll('[data-dk-tabs]').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp-tab-btn');
      if (!btn) return;
      tabs.querySelectorAll('.pdp-tab-btn').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      tabs.querySelectorAll('.pdp-tab-panel').forEach(function (p) {
        p.classList.toggle('active', p.getAttribute('data-panel') === btn.getAttribute('data-tab'));
      });
    });
  });
})();

/* Produktvideo: YouTube lädt erst nach dem Klick. Sprungziel #video nach dem Laden nochmal anfahren,
   weil die Galerie darüber die Position verschiebt (QR-Codes auf den Verpackungen). */
(function () {
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-dk-video-play]');
    if (!play) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + play.getAttribute('data-dk-video-play') + '?autoplay=1&rel=0&playsinline=1';
    f.title = play.getAttribute('aria-label') || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    play.replaceWith(f);
  });
  if (location.hash === '#video') {
    window.addEventListener('load', function () {
      var v = document.getElementById('video');
      if (v) v.scrollIntoView();
    });
  }
})();
